import { PopularDestinations } from 'shared/seo/PopularDestinations';
import { InternalLinksSection } from '@/components/internalLinks/InternalLinksSection';
import { transformDestinations } from '@/components/internalLinks/transformDestinations';
import carRentalData from './data/carrental.json';
import data from './data/fhh.json';
import { toDestinations } from './toDestinations';

export const FhhSeo = () => {
    const europeAccordionItems = transformDestinations(data.europeAccordion, 'feriehus-hytteutleie');

    const norwayCities = toDestinations(data.norwayCities, data.cdnPath, data.basePath, data.altPrefix);
    const europeCountries = toDestinations(data.europeCountries, data.cdnPath, data.basePath, data.altPrefix);
    const carRentalCountries = toDestinations(
        carRentalData.countries,
        carRentalData.cdnPath,
        carRentalData.basePath,
        carRentalData.altPrefix,
    );

    return (
        <>
            <PopularDestinations id="seo-fhh-norway" heading={data.norwayCitiesHeading} destinations={norwayCities} />
            <InternalLinksSection
                title="Finn flere hytter og feriehjem til leie i Norge"
                titleId="seo-fhh-more-norway"
                items={data.norwayAccordion}
            />
            <PopularDestinations id="seo-fhh-europe" heading={data.europeCountriesHeading} destinations={europeCountries} />
            <InternalLinksSection title="Se våre mest populære steder" titleId="seo-fhh-popular-europe" items={europeAccordionItems} />
            <PopularDestinations id="seo-fhh-carrental" heading={carRentalData.countriesHeading} destinations={carRentalCountries} />
        </>
    );
};
